import { getActivePinia, type Pinia } from 'pinia';

// Ce que la session d'un préparateur a chargé : les commandes, la liste à sortir, l'historique.
const SESSION_STORES = ['pds-orders', 'pds-stock', 'pds-history'];

interface DisposableStore {
  $dispose: () => void;
  stopTimers?: () => void;
}

// À la déconnexion, la page n'est plus rechargée : ces données sont jetées ici, pour que la session suivante
// (peut-être un autre commerce) reparte de rien au lieu de montrer, un instant, les commandes de la précédente.
export const resetPdsSession = (
  pinia: Pinia | undefined = getActivePinia(),
) => {
  if (!pinia) return;
  const stores = (pinia as unknown as { _s: Map<string, DisposableStore> })._s;
  for (const id of SESSION_STORES) {
    const store = stores.get(id);
    store?.stopTimers?.();
    store?.$dispose();
    delete pinia.state.value[id];
  }
};
